import { observer } from 'mobx-react-lite';
import { CreateUser } from 'components/admin/CreateUser';
import { useRootStore } from 'stores/RootStore';
import { UserList } from 'components/admin/UserList';
import { EditUser } from 'components/admin/EditUser';
import { Link, NavigationPage } from 'components/NavigationPage';

const links: Link[] = [
  {
    route: 'createUser',
    text: 'Create User',
  },
  {
    route: 'editUsers',
    otherRoutes: ['editUser'],
    text: 'Edit Users',
  },
];

const AdminPage = observer(() => {
  const { authStore, routeStore, createUserStore, editUserStore, userListStore } = useRootStore();
  const { route, navigateByName, goHome } = routeStore;
  const { currentUser } = authStore;

  return (
    <NavigationPage
      links={links}
      route={route}
      navigateByName={navigateByName}
      onBack={route === 'editUser' ? () => navigateByName('editUsers') : goHome}
      renderBody={({ scrollToTop }) => (
        <>
          {route === 'createUser' && <CreateUser scrollToTop={scrollToTop} createUserStore={createUserStore} />}
          {route === 'editUsers' && (
            <UserList currentUser={currentUser} navigateByName={navigateByName} userListStore={userListStore} />
          )}
          {route === 'editUser' && <EditUser scrollToTop={scrollToTop} editUserStore={editUserStore} />}
        </>
      )}
    />
  );
});

export { AdminPage };
